import { Action, ActionTree, ActionContext } from 'vuex'

import WebSocketService from '@/system/socket/socket.service'
import { ISocketState } from '@/system/socket/store'
import { CONNECT_WS, CLOSE_WS, FETCH_CUSTOMERS } from '@/system/store/action-types'
import { GET_AUTH, GET_SELECTED_CUSTOMER } from '@/system/store/getter-types'
import { SOCKET_ONCLOSE } from '@/system/store/mutation-types'

const connectWS: Action<ISocketState, any> = async (
  context: ActionContext<ISocketState, any>
) => {
  const service = new WebSocketService()

  const { token } = context.getters[GET_AUTH]
  const { id: customer } = context.getters[GET_SELECTED_CUSTOMER]

  await service.connect({ token, customer })
}

const closeWS: Action<ISocketState, any> = (
  context: ActionContext<ISocketState, any>
) => {
  context.commit(SOCKET_ONCLOSE)
}

const actions: ActionTree<ISocketState, any> = {
  [CONNECT_WS]: connectWS,
  [CLOSE_WS]: closeWS
}

export default actions
